module.exports = __webpack_public_path__ + "static/media/quotepad.0e6fd312.PNG";